import {
  EmotionWHeelPageQuery,
  EmotionWHeelQuery,
  EmotionWheelEntity,
  EmotionWheelPage,
} from '@/graphql/generated/graphql';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_EMOTION_WHEEL, QUERY_EMOTION_WHEEL_PAGE } from '@/graphql/queries/daily/emotion-wheel';
import { MUTATION_UPDATE_USER_TRACKING } from '@/graphql/mutations/on-boarding/user';
import { getAuthentication } from '@/hooks/useAuthentication';

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<EmotionWHeelPageQuery>({
      query: QUERY_EMOTION_WHEEL_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  return {
    page: data?.emotionWheelPage?.data?.attributes as EmotionWheelPage,
    error,
  };
};

export const getEmotionWheel = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<EmotionWHeelQuery>({
      query: QUERY_EMOTION_WHEEL,
    }),
  );

  return {
    emotions: data?.emotionWheels?.data as EmotionWheelEntity[],
    error,
  };
};

export async function onChangeTrackingEmotions(disable: boolean) {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate({
      mutation: MUTATION_UPDATE_USER_TRACKING,
      variables: {
        id: getAuthentication()?.user?.id,
        input: {
          isEmotionWheelTrackingDisabled: disable,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}

export async function onChangeOnboardStatus() {
  const apolloClient = initializeApollo();

  const { data } = await requestHandler(
    apolloClient.mutate({
      mutation: MUTATION_UPDATE_USER_TRACKING,
      variables: {
        id: getAuthentication()?.user?.id,
        input: {
          onboardEmotionWheelCompleted: true,
        },
      },
    }),
  );

  return data?.updateUsersPermissionsUser?.data?.attributes;
}
